import React from 'react';
import { FC } from 'react';
import { IconProps } from '../types';

export const ClockIcon: FC<IconProps> = ({ width = '24', height = '24', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
      stroke={'currentColor'}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M12 6V12L16 14' stroke={'currentColor'} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
